// extracted by mini-css-extract-plugin
export default {"container":"FormContainer_container__AOill","header":"FormContainer_header__JEJHO","body":"FormContainer_body__BUaH6","closeDiv":"FormContainer_closeDiv__ukvlf"};